import { createContext, useContext, useState, useEffect } from 'react'
import api from '../services/api'
import { aplicarCorPrimaria } from '../utils/cor'

const ConfigContext = createContext()

const CONFIG_PADRAO = { nome: 'Emseg Corretora de Seguros', logo: null, cor_primaria: '#DD3B00' }

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(CONFIG_PADRAO)

  const carregar = () => api.get('/config/corretora')
    .then(r => {
      const dados = { ...CONFIG_PADRAO, ...r.data }
      setConfig(dados)
      aplicarCorPrimaria(dados.cor_primaria)
    })
    .catch(() => {})

  useEffect(() => { carregar() }, [])

  return (
    <ConfigContext.Provider value={{ config, refreshConfig: carregar }}>
      {children}
    </ConfigContext.Provider>
  )
}

export const useConfig = () => useContext(ConfigContext)
